module.exports = __webpack_public_path__ + "img/FTP-empty.310c708b.png";